import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13.956 20.934"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "var(--fill-0, #001A42)" }, [
      _createElementVNode("path", { d: "M0 10.43c.31.176.643.316.985.429 1.246.41 2.81.502 4.358.531.334.895.458 2.073.337 3.372a.17.17 0 0 0 .124.18.17.17 0 0 0 .196-.094c.813-1.768 1.962-3.029 3.08-3.38 1.229.071 2.31.225 3.155.579.626.262 1.065.612 1.343 1.079.182.306.32.704.37 1.23h-.004a6.978 6.978 0 0 1-13.933 0H0zM6.978 0a6.98 6.98 0 0 1 6.977 6.978v3.98a5.3 5.3 0 0 0-1.028-.564c-1.255-.526-2.817-.688-4.365-.745-.309-.897-.416-2.058-.288-3.333a.156.156 0 0 0-.115-.166.156.156 0 0 0-.182.087c-.754 1.671-1.808 2.9-2.86 3.355-1.396-.034-2.624-.123-3.572-.435C.902 8.946.485 8.66.233 8.3A1.8 1.8 0 0 1 0 7.825v-.847A6.98 6.98 0 0 1 6.978 0" })
    ], -1)
  ]))]))
}
export default { render: render }